<template>
  <div>
    <vm-table
        ref="vmTable"
        height="65vh"
        :filter.sync="filter"
        module="basic"
        url="applications/todo/all">
      <div slot="toolbar">
        <el-button :loading="exportLoading" type="primary" @click="exportExcel">导出</el-button>
      </div>
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="单据类型">
            <el-select v-model="filter.formText">
              <el-option value="订单" label="销售订单"/>
              <el-option value="订单变更" label="订单变更"/>
            </el-select>
          </vm-search>
          <vm-search label="单据编号">
            <el-input v-model.trim="filter.billNO" clearable/>
          </vm-search>
          <vm-search label="节点名称">
            <el-input v-model.trim="filter.descrpt" clearable/>
          </vm-search>
          <el-row>
            <vm-search label="创建时间">
              <div class="block">
                <el-date-picker
                    v-model="filter.startTime"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    type="date"
                    style="width: 165px"
                    placeholder="选择开始时间"/>
              </div>
            </vm-search>
            <vm-search label="至">
              <div class="block">
                <el-date-picker
                    v-model="filter.endTime"
                    value-format="yyyy-MM-dd 23:59:59"
                    type="date"
                    style="width: 165px"
                    placeholder="选择结束时间"/>
              </div>
            </vm-search>
          </el-row>
        </div>
      </template>
      <!--      <el-table-column prop="sequID" label="主键"/>-->
      <el-table-column prop="formText" label="单据类型" width="80" align="center"/>
      <el-table-column prop="billNO" label="单据编号"/>
      <el-table-column prop="projectName" label="项目名称" width="300"/>
      <el-table-column prop="customerName" label="客户名称"/>
      <el-table-column prop="descrpt" label="节点名称"/>
      <el-table-column prop="employeeName" label="处理人"/>
      <el-table-column prop="createdTime" label="创建时间"/>
    </vm-table>
  </div>
</template>
<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  export default {
    name: "TodoList",
    components: {VmTable, VmSearch},
    data() {
      return {
        exportLoading:false,
        filter: {
          formText: "订单",
          billNO: "",
          descrpt: "",
          startTime: "",
          endTime: "",
        },
      };
    },
    mounted() {
      this.getList(1);
    },
    methods: {
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      exportExcel() {
        this.exportLoading = true;
        this.$http
          .exportFile("basic","applications/exportList", this.filter)
          .then(res => {
            console.log(res);
            let blob = new Blob([res.data]);
            let fileName = decodeURI(res.headers.filename);
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              navigator.msSaveBlob(blob, fileName);
            } else {
              let a = document.createElement("a");
              a.href = URL.createObjectURL(blob);
              a.download = fileName;
              a.style.display = "none";
              document.body.appendChild(a);
              a.click();
              URL.revokeObjectURL(a.href);
              document.body.removeChild(a);
            }
            this.exportLoading = false;
          })
          .catch(() => {
            this.exportLoading = false;
          });
      },
    },
  };
</script>
<style lang="scss" scoped>
</style>
